import { lazy } from 'react';

export const SignUp = lazy(() => import('./SignUp.component'));
